import register from 'ShopUiBundle/modules/app/registry';
import 'ShopUiBundle/components/molecules/range-slider';
import './range-slider-scroll-x-container.scss';

// tslint:disable-next-line
register('range-slider-scroll-x-container', () => import(/* webpackMode: "lazy" */'./range-slider-scroll-x-container'));
